<template>
	<a :class="{ active: isActive }" @click="toggleState" class="btn vote-button">
		<span class="state">
			<i class="fas" :class="'fa-arrow-' + voteType"></i>
			<span v-text="voteTypeName" class="vote-button__text"></span> <span :class="countClass(count)">{{count}}</span>
		</span>
		<span class="state">
			<i class="fas vote-button__icon vote-button__icon--active" :class="'fa-arrow-' + voteType"></i>
			<span v-text="voteTypeName + 'd'" class="vote-button__text"></span> <span :class="countClass(count + 1)">{{count + 1}}</span>
		</span>
	</a>
</template>


<script>
	import api from './api'

	export default {
		name: 'VoteComponent',
		props: ['active', 'votableId', 'voteType', 'voteCount'],
		data: function () {
			return {
				isActive: false,
				count: 0
			};
		},

		computed: {
			voteTypeName: function () {
				return this.voteType === 'up' ? 'Upvote' : this.voteType === 'down' ? 'Downvote' : '';
			}
		},
		methods: {
			toggleState () {
				if (!Grabcad.authenticated) {
					return window.$$loginEventHub.$emit('signInModalTrigger');
				}

				this.isActive = !this.isActive;
				this.deactivateSibling();
				this.makeRequest();
			},

			makeRequest () {
				api.vote(this.votableId, this.voteType).catch(this.handleRequestError);
			},

			handleRequestError (err) {
				Raygun && Raygun.send(err);
			},

			deactivateSibling () {
				this.$eventHub.$emit('deactivate', this.votableId, this.voteType);
			},

			deactivate (votableId, voteType) {
				if (this.votableId === votableId && this.voteType !== voteType) {
					this.isActive = false;
				}
			},
			countClass: function (count) {
				if (count > 0) return 'not-zero';
				return 'zero';
			}
		},
		mounted: function () {
			this.isActive = this.active === 'true';
			this.count = this.isActive ? this.voteCount - 1 : this.voteCount;
			this.$eventHub.$on('deactivate', this.deactivate);
		}
	}
</script>